var map = {
	"./fa-b2b-img1.png": 3786,
	"./fa-b2b-img2.png": 3787,
	"./fa-b2b-img3.png": 3788,
	"./fa-b2b-img4.png": 3789,
	"./fa-b2b-img5.png": 3790,
	"./fa-b2b-img6.png": 3791
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5070;